/* 🤖 this file was generated by svg-to-ts */
export const matIconTablet: {
  name: 'tablet';
  data: string;
} = {
  name: 'tablet',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M21 4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 1.99-.9 1.99-2L23 6c0-1.1-.9-2-2-2zm-2 14H5V6h14v12z"/></svg>`
};
